<template>
  <div class="contents_wrapper">
    <div class='contents'>
      <h2 class="large_blue_label">発注サポートデスク</h2>
      <h3 class="large_black_label">TEL: 070-8332-7182 （平日 9:00～17:00）</h3>

      <p class="bold_label">または下記、お問い合わせフォームよりご連絡ください。</p>

      <div class="contact-trouble_block">
        <div class="left">
          <img class='base_image title_dm' src='@/assets/image/pages/information/contact/trouble.jpg'>
        </div>
        <div class="right">
          <ul>
            <li>・ 作業時間が8時間を超える仕事を依頼したい。</li>
            <li>・ 利用方法がよく分からない。</li>
            <li>・ 発注金額の相場や、作業時間の見積りが分からない。</li>
            <li>・ 依頼したい仕事があるが、フルーで扱っているか分からない。</li>
            <li>・ オペレーターとうまくコミュニケーションが取れるか心配。</li>
            <li>・ オペレーターのパソコンがウイルス対策してあるか心配。</li>
          </ul>
          等々…
        </div>
      </div>

      <p class="bold_label">そんなお悩みは <span class="little-large-bold_label">発注サポートデスク</span> にご相談ください！</p>

      <div class="contact-support_block">
        <div class="left">
          <img class='base_image title_dm' src='@/assets/image/pages/information/contact/support.jpg'>
        </div>
        <div class="right">
          <ul>
            <li>・ 作業時間が8時間を超えるお仕事につきましては、事務局にてオペレーターの方と調整いたします。</li>
            <li>・ お電話やメール、ZOOMなどで利用方法を丁寧に説明いたします。</li>
            <li>・ 作業内容を詳しくお伺いし、発注金額や作業時間の見積りをご支援いたします。</li>
            <li>・ 作業内容に適したオペレーターを事務局にて選定し、事前にオペレーターと調整した上でご提案いたします。</li>
            <li>・ オペレーターと直接やり取りせず、事務局が間に入る方法を取ることも可能です。</li>
            <li>・ オペレーターに対する情報セキュリティ要件にもお応えいたします。</li>
          </ul>
          等々…
        </div>
      </div>

      <h2 class="large_blue_label">お問い合わせ</h2>
      <InquiryBox/>
    </div>
  </div>
</template>

<script>

  import InquiryBox from "@/components/objects/block/contact/InquiryBox";

  export default {
    name: 'Contact',
    components: {InquiryBox},
  }
</script>

<style lang="scss" scoped>
  .contents_wrapper {

    > .contents {
      @include contents();

      > h2, > .inquiry_box {
        width: 100%;
      }

      > .contact-trouble_block, > .contact-support_block {
        @include double_columns(25%, 55%);
        margin: 6rem 0;
        > ul {

        }
      }

      > .inquiry_box {
        margin-bottom: 2rem;
      }
    }
  }
</style>